import { Pipe, PipeTransform } from '@angular/core';

import { ClienteSituacao, clienteSituacoes } from '../cliente-situacao';

@Pipe({
    name: 'clienteSituacaoCadastrosFilter',
    pure: false
})
export class ClienteSituacaoCadastrosFilterPipe implements PipeTransform {
    transform(cadastros: number[] = [], situacoesExcludes: number[] = []): ClienteSituacao[] {
        // Se não for filtrado por nenhum cadastro, então retorna todas as situações
        if (!cadastros || cadastros.length === 0) {
            return clienteSituacoes;
        }

        // Filtra somente as situações que pertencem a algum dos cadastros filtrados
        let situacoes = clienteSituacoes.filter(situacaoFilter => situacaoFilter.cadastros.some(cadastro => cadastros.includes(cadastro)));

        if (situacoesExcludes) {
            situacoes = situacoes.filter(situacaoFilter => !situacoesExcludes.includes(situacaoFilter.id));
        }

        return situacoes;
    }
}
